module.exports = [{"value":"Swap","text":"Swap"},{"value":"เจาะเลือด","text":"เจาะเลือด"}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/master/vaccine/typeCheckCovid.json
// module id = scKZ
// module chunks = 2